import { Component, OnInit } from '@angular/core';
import { LetterRequestCustomer_List_Interface } from 'src/app/Interface/LetterRequestCustomer_List_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { LetterRequestCustomerService } from 'src/app/Service/Letter/LetterRequestCustomer.service';
import { LoginService } from 'src/app/Service/Login/Login.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-LetterRequestCustomerFormCustomer',
  templateUrl: './LetterRequestCustomerFormCustomer.component.html',
  styleUrls: ['./LetterRequestCustomerFormCustomer.component.scss']
})
export class LetterRequestCustomerFormCustomerComponent implements OnInit {

  Token:string=""
  page:number=0;
  Procssing:boolean=false

  StartSearchDate:String=''
  EndSearchDate:String=''
  CustomerName:String=''

  BaseUrl = environment.BaseUrl + "Letterrequestcustomerprint/Show?id="

  constructor(
    private login_Service: LoginService,
    private Nav_Service:NavService,
    private Alertify_Service:AlertifyService,
    private LetterRequestCustomer_Service:LetterRequestCustomerService,
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');

    this.BaseUrl=environment.BaseUrl + "Letterrequestcustomerprint/Show?token="+ this.Token+"&id="

    this.Nav_Service.CheckValidPage(this.Token,1141).subscribe(
      data=>{
        this.login_Service.GetUserRole(this.Token).subscribe(
          data2=>{
            this.CustomerName=data2['customerName']
          }
        )
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )
  }

  DataList_LetterRequestCustomer:Array<LetterRequestCustomer_List_Interface>=[]
  GetLetterRequestCustomerSadereh(StartSearchDate,EndSearchDate){
    this.Procssing=true
    this.LetterRequestCustomer_Service.GetLetterRequestCustomerSadereh(
      StartSearchDate,
      EndSearchDate,
      this.Token).subscribe(
      data=>{
        this.DataList_LetterRequestCustomer=data

        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }


}

